import { AfterContentInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { XpoBaseDatePickerDirective } from './datepicker-base.directive';

const XPO_DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Directive({
  selector: '[xpoDatePicker]',
  host: {
    class: 'xpo-DatePicker',
  },
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: XPO_DATEPICKER_FORMATS },
  ],
})
export class XpoDatePickerDirective extends XpoBaseDatePickerDirective implements AfterContentInit {
  // TODO: Remove and only keep constructor in parent class using empty @Directive decorator (NGXLTL-732)
  constructor(protected element: ElementRef, protected renderer: Renderer2) {
    super(element, renderer);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();

    this.datePickerMatInput.placeholder = XPO_DATEPICKER_FORMATS.display.dateInput;
  }
}
